import React, { Component } from 'react'
import styled from 'styled-components'
import RegButton from '../../components/Button'
import Row from '../../components/Row'
import Text from '../../components/Text'

const Wrap = styled.div`
  display: flex;
  width: 100%;
`

const Icon = styled.i`
  font-size: 1.1rem;
`

const TextWrap = styled.div`
  flex: 1;
`

export default class Button extends Component {
  render() {
    const { str, next, prev, ...props } = this.props

    return (
      <Row.Cell>
        <RegButton {...props}>
          <Wrap>
            {prev && <Icon className="fas fa-chevron-left" />}
            <TextWrap>
              <Text str={str} />
            </TextWrap>
            {next && <Icon className="fas fa-chevron-right" />}
          </Wrap>
        </RegButton>
      </Row.Cell>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Paginate/Button.js